import React from "react";

const Constants = () => {
  return (
    <div>
      <h1>Constants Component</h1>
      <p>Content for Constants goes here...</p>
    </div>
  );
};

export default Constants;
